var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36605 7.26113L0.264458 2.65319C-0.0881526 2.3347 -0.0881526 1.8197 0.264458 1.5046L1.11222 0.738867C1.46483 0.420378 2.03501 0.420378 2.38387 0.738867L6 4.00508L9.61613 0.738867C9.96874 0.420378 10.5389 0.420378 10.8878 0.738867L11.7355 1.5046C12.0882 1.82309 12.0882 2.33809 11.7355 2.65319L6.63395 7.26113C6.28884 7.57962 5.71866 7.57962 5.36605 7.26113Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/Vector_5.f99c15ef626b299eea5bdfb84026c82d.svg";
export { ForwardRef as ReactComponent };